import { CircularProgress, Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import api from 'api';
import { Field, Formik } from 'formik';
import { Notify } from 'utils';
import Fields from 'components/Fields';
import { Button } from 'components/Base';

interface LegalRelationshipProps {
  data: any;
  classes: any;
  updateData: Function;
}

const LegalRelationship = ({
  data,
  classes,
  updateData
}: LegalRelationshipProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [allLegalRelationships, setAllLegalRelationships] = useState([] as any);

  useEffect(() => {
    setIsLoading(true);
    api.getLegalRelationships().then(({ data }: any) => {
      setAllLegalRelationships(data);
      setIsLoading(false);
    });
  }, []);

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress size="80px" />
    </div>
  ) : (
    <Formik
      enableReinitialize
      initialValues={{
        legalRelationships: allLegalRelationships.map(
          (legalRelationship: any) =>
            data.legal_relationships?.includes(Number(legalRelationship.value))
        )
      }}
      onSubmit={values => {
        setIsSaving(true);

        api
          .updateMpsProvider(data.id, {
            legal_relationships: values.legalRelationships
              .map((legalRelationship: boolean, index: number) =>
                legalRelationship
                  ? Number(allLegalRelationships[index].value)
                  : false
              )
              .filter(Boolean)
          })
          .then((response: any) => {
            updateData({ ...data, platforms: response.data });
            Notify.success('Legal relationship updated successfully.');
          })
          .catch(() => {
            Notify.error('Legal relationship could not be updated.');
          })
          .finally(() => {
            setIsSaving(false);
          });
      }}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <Grid container>
              {allLegalRelationships.map((platform: any, index: number) => (
                <Grid key={index} item xs={12} className={classes.row}>
                  <div style={{ marginRight: '0.5rem' }}>
                    <Field
                      component={Fields.v2.Checkbox}
                      name={`legalRelationships[${index}]`}
                    />
                  </div>
                  {platform.name}
                </Grid>
              ))}
            </Grid>
          </div>
          <div>
            <Button type="submit" disabled={isSaving} isLoading={isSaving}>
              Save
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default LegalRelationship;
